/**
 * Ryan O'Dowd
 * 2024-09-22
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({colors}) => {
  return {
    container: {
      position: 'absolute',
    },
    listItemContainer: {
      paddingHorizontal: 0,
    },
    listItemInner: {
      marginHorizontal: 4,
      backgroundColor: 'transparent', // @TODO: props.complete ? `${colors.accent}22` : 'transparent',
      padding: 0,
    },

    // @TODO: duplicated in Goals/styles.native.js; yeet after removing walkthrough as dep {
    walkthroughContentRow: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'flex-start',
      marginTop: 8,
      marginBottom: 8,
      marginRight: 8,
    },
    walkthroughText: {
      display: 'flex',
      flexShrink: 1,
      width: '100%',
      height: '100%',
      padding: 4,
      alignSelf: 'flex-start',
      color: colors.primaryExtraDark,
    },
    // @TODO: duplicated in Goals/styles.native.js }
  };
};

export default getStyles;
